export default {
    errorModalGenericTitle:"Atenção",
    errorModalGenericDescription:"Tem ocorrido um erro. Por favor tenta a operação novamente. ",
    reportError:'Se o problema persiste pode reportar o erro a través dosistema de consulta, fazendo clique',
    mailTo:'mailto:atendimento@plataforma10.com',
    clickHere:'aqui.'
}